import PinSetScreen from 'features/cardManagement/screens/PinSet/PinSetScreen';
import React from 'react';

export default function ChangePinPage() {
  return <PinSetScreen />;
}
